import { render, staticRenderFns } from "./comForm.vue?vue&type=template&id=56364b93&scoped=true&"
import script from "./comForm.vue?vue&type=script&lang=ts&"
export * from "./comForm.vue?vue&type=script&lang=ts&"
import style0 from "./comForm.vue?vue&type=style&index=0&id=56364b93&prod&lang=css&"
import style1 from "./comForm.vue?vue&type=style&index=1&id=56364b93&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56364b93",
  null
  
)

export default component.exports